import React, { useEffect, useState } from 'react';

import styles from './DogOverview.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../Auth';
import { useAxios } from '../../../../../AxiosHandler';
import Card from '../../../../Shared/Card/Card';
import DogCardHealthOverview from './DogCardHealthOverview/DogCardHealthOverview';
import DogCardUseOverview from './DogCardUseOverview/DogCardUseOverview';
import { general } from '../../../../../general';
import TextLink from '../../../../Shared/TextLink/TextLink';
import DogCardGeneralOverview from './DogCardGeneralOverview/DogCardGeneralOverview';
import DogCardOwnerOverview from './DogCardOwnerOverview/DogCardOwnerOverview';
import DogCardBreedingOverview from './DogCardBreedingOverview/DogCardBreedingOverview';

function DogOverview(props: DogOverviewProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const canSeeOwner = general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ||
        general.getBreedAccess(auth.user, auth.selectedBreed) == "user";

    // Hund, Eier, Avl, Bruk, Helse side by side: as many columns as the width
    // allows, up to all five on wide screens (see DogOverview.module.scss)
    return (
        <div className={styles.dogoverview}>
            <div className={styles.grid}>
                <div className={styles.cell}>
                    <DogCardGeneralOverview
                        title={props.selectedDog?.NAME}
                        selectedDog={props.selectedDog}
                        dogId={props.selectedDogId}
                    ></DogCardGeneralOverview>
                </div>
                { canSeeOwner ?
                    <div className={styles.cell}>
                        <DogCardOwnerOverview
                            title={t("dog.details.owner.title")}
                            dogId={props.selectedDogId}
                            statusDisabled={true}
                        />
                    </div>
                : null }
                <div className={styles.cell}>
                    <DogCardBreedingOverview
                        title={t("dog.details.breeding.title")}
                        dogId={props.selectedDogId}
                        statusDisabled={true}
                    />
                </div>
                <div className={styles.cell}>
                    <DogCardUseOverview
                        title={t("dog.details.use.title")}
                        dogId={props.selectedDogId}
                        statusDisabled={true}
                    />
                </div>
                <div className={styles.cell}>
                    <DogCardHealthOverview
                        title={t("dog.details.health.title")}
                        dogId={props.selectedDogId}
                        statusDisabled={true}
                    />
                </div>
            </div>
        </div>
    );
}

class DogOverviewProps {
    selectedDogId!: string | undefined;
    selectedDog!: any | undefined;
}

export default DogOverview;